// src/services/authService.js
import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getFrequence = async (user) => {
    return userRequest.get(`${DOMAIN}/api/frequence`);
  };

export const getFrequenceOne= async (id) => {
    return userRequest.get(`${DOMAIN}/api/frequence/one?id_frequence=${id}`);
  };

export const postFrequence = async (data) => {
  return userRequest.post(`${DOMAIN}/api/frequence`, data);
};

export const deleteFrequence = async (id) => {
    return userRequest.delete(`${DOMAIN}/api/frequence/${id}`,);
  };
  
export const putFrequence = async (id, data) => {
    return userRequest.put(`${DOMAIN}/api/frequence?id_frequence=${id}`, data);
  };
  

